import { createFileRoute } from "@tanstack/react-router";
import DashboardRootUser from "@/features-root-user/dashboard";
import { dashboardQueryOptions } from "@/features-root-user/service/dashboard";
import { queryClient } from "@/main";

export const Route = createFileRoute("/_root/root-user/dashboard/")({
  component: DashboardRootUser,
  loader: async () => {
    queryClient.ensureQueryData(dashboardQueryOptions);
  },
});
